import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLiff } from "react-liff";

import Layouts from "layouts/Layouts";
import LoaderPage from "./components/loader/LoaderPage";
import AppRouter from "./appRouter"; // Router

import useProfileStore from "services/store/ProfileModule";
import VConsole from "vconsole";

function App() {
    // const vConsole = new VConsole();
  const { isLoggedIn, isReady, liff } = useLiff()

  // CENTER STATE
  const { profile } = useProfileStore(); // STATE
  const { getCustomerProfile, setProfile } = useProfileStore(); // ACTION

  // LOCAL STATE
  const [ isDone, setIsDone] = useState(false);
  const [ lineId, setLineId ] = useState(false);
  const [ isHasProfile, setIsHasProfile] = useState(false);

  // เรียกข้อมูล Customer SNOWBALL API Part 2
  const fetchCustomerProfile = async (lineUid) => {
    console.log("🚀 ~ fetchCustomerProfile ~ lineUid:", lineUid)
    try {
      const resData = await getCustomerProfile(lineUid)
      if (resData.code === 20000) {
        setIsHasProfile(true)
      }
      setIsDone(true)
    }
    catch (err) {
      console.log('err ', err)
      setIsDone(true)
    }
  }

  // เรียกข้อมูล LINE_UID
  useEffect(() => {
    if (!isLoggedIn) return;
    (async () => {
      try {
        const profile = await liff.getProfile();
        console.log("🚀 ~ APP profile:", profile)

        if (profile) {
          let tmpProfile = { isLoaded: true, lineUid: profile.userId, profile: profile }
          console.log("🚀 ~ APP tmpProfile:", tmpProfile)
          setProfile(tmpProfile)
          setLineId(profile.userId)
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, [ liff, isLoggedIn ]);

  // เรียกข้อมูล Customer SNOWBALL API Part 1
  useEffect(() => {
    console.log('lineId >>', lineId)
    if (lineId) {
      fetchCustomerProfile(lineId)
    }
  }, [lineId])


  if (!isReady && !isDone) {
    return <LoaderPage />
  }

  return (
    <Layouts>
      <AppRouter isHasProfile={isHasProfile}/>
    </Layouts>
  );
}

export default App;
